// @flow
import React from 'react'
import AnimationSlice from './AnimationSlice'
import AnimationAttack from './AnimationAttack'
import AnimationForEach from './AnimationForEach'
import AnimationTeamForEach from './AnimationTeamForEach'
import AnimationHeadphones from './AnimationHeadphones'
import AnimationTroll from './AnimationTroll'
import AnimationFillHp from './AnimationFillHp'

export function getAnimation(key: string, properties: Object) {

  //Ensure properties is defined
  properties = properties || {};
    //Firebase will eat this object if it's empty.
    // Some animations don't need to pass properties data (because they are just a sound, like AnimationFillHp)
    // This line ensures we have an empty object and not `undefined`


  const animations = {
    AnimationAttack: (
      <AnimationAttack
        casterId={properties.casterId}
        targetIds={properties.targetIds}
      />
    ),
    AnimationSlice: (
      <AnimationSlice
        casterId={properties.casterId}
        targetIds={properties.targetIds}
      />
    ),
    AnimationForEach: (
      <AnimationForEach
        casterId={properties.casterId}
        targetIds={properties.targetIds}
        targetsDamageTracker={properties.targetsDamageTracker}
      />
    ),
    AnimationTeamForEach: (
      <AnimationTeamForEach
        casterId={properties.casterId}
        targetIds={properties.targetIds}
        targetsDamageTracker={properties.targetsDamageTracker}
      />
    ),
    AnimationHeadphones: (
      <AnimationHeadphones
        casterId={properties.casterId}
        targetIds={properties.targetIds}
      />
    ),
    AnimationTroll: (
      <AnimationTroll
        casterId={properties.casterId}
        targetIds={properties.targetIds}
      />
    ),
    AnimationFillHp: (
      <AnimationFillHp />
    )
  };

  if (!animations[key]) {
    console.warn('no Animation Key found!', key)
  }

  return animations[key]
}



// WEBPACK FOOTER //
// ./src/battle/ArenaView/animation-components/getAnimation.js